<template>
  <div class="page-container">
    <!-- <div class="query-title">制票通知单明细查询</div> -->

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <!-- <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
            <table-button v-if="!$_has('WLY001')" name="save" tip="保存EMS" @click="saveESM('BUTTON_EMS')" />
            <table-button v-if="$_has('WLYALL')" name="advance" tip="发票特殊修改" @click="editNum" />
            <table-button name="export" tip="发运签收表导出" @click="exportSign" />
            <table-button name="export" tip="打印EMS单地址" @click="printEMS" />
            <table-button name="export" tip="打印签收表" @click="showSigin" />
          </template> -->
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :cell-class-name="cellClassName"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #invo_infoid="{ row }">
              <span class="blue" @click="toDetail(row)">{{ row.invo_infoid }}</span>
            </template>
            <template #approve="{ row }">
              <span v-if="row.button === 'X'" class="button-approve" @click="approve(row, 'APPROVE')">审核通过</span>
            </template>
            <!-- <template #saveESM="{ row }">
              <span v-if="row.button_ems === 'X'" class="button-approve" @click="approve(row, 'BUTTON_EMS')">保存EMS单号</span>
            </template> -->
            <template #manual_invo="{ row }">
              <el-input v-model="row.manual_invo" size="mini" />
            </template>
            <template #invo_id="{ row }">
              <el-input v-model="row.invo_id" size="mini" />
            </template>
            <template #ems_number="{ row }">
              <el-input v-model="row.ems_number" size="mini" />
            </template>
            <template #pdf_url="{ row }">
              <span style="cursor: pointer;color:#2992f6" @click="openPDF(row.pdf_url)">预览</span>
              <!-- <el-input v-model="row.ems_number" size="mini" /> -->
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="签收表打印"
      :visible.sync="showTypeDialog"
      width="500px"
      :append-to-body="true"
    >
      <div v-if="showTypeDialog">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :columns="siginColumn"
          :data="siginType"
        />
      </div>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialogType = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitType"
        >确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="打印浏览"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showPDFDialog"
      title="预览发票信息"
      width="70%"
      top="5vh"
      v-drag-resize
      :close-on-click-modal = "false"
    >
      <iframe :src="PDFurl" frameborder="0" style="width: 100%;height: 100%;min-height:600px" />
    </el-dialog>

  </div>
</template>

<script>
import {
  apiMakeInvoiceDetailList,
  apiApprove,
  apiEditInvoice,
  printEMSAddress
} from '@/api/sap/make-invoice-sap'
import { mapGetters } from 'vuex'
import tableMixins from '@/utils/tableMixins'
import pageConfig from '../config/invoiceDetailQuery'
import { hexToBytes } from '@/utils/frontExport'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      showTypeDialog: false,
      siginColumn: [
        { type: 'radio', field: 'radio', title: '', width: 50 },
        { field: 'name', title: '类型' }
      ],
      siginType: [
        { name: '发运' },
        { name: '发票' }
      ],
      showDialog: false,
      url: '',
      showPDFDialog:false,
      PDFurl:'',
      gridOptions: {
        columns: [
          { type: 'radio', field: 'radio', title: '', width: 50 }
        ],
        data: []
      },
      searchField: {},
      isRadio: true,
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
    if (this.role.ROLE === 'WLY001') {
      this.gridOptions.columns.forEach(item => {
        if (['approve'].includes(item.field)) {
          item.visible = false
        } else if (['manual_invo', 'invo_id', 'ems_number'].includes(item.field)) {
          delete item.slots
        }
      })
    }
  },
  methods: {
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      if (this.isRadio) {
        // 单选
        const selectData = this.$refs.xTable.getRadioRecord()
        if(!selectData)return Promise.reject('请选择有效数据！')
        console.log(`output->selectData`,selectData)
        return Promise.resolve(selectData)
      } else {
        // 多选
        const selectData = this.$refs.xTable.getCheckboxRecords()
        return Promise.resolve(selectData)
      }
    },
    openPDF(url){
      this.PDFurl = url;
      this.showPDFDialog = true;
    },
    cellClassName({ column, rowIndex }) {
      if (this.tableCountData.length) {
        if (this.showHeader && rowIndex === 0) {
          return ''
        } else if (rowIndex === this.gridOptions.data.length - 1) {
          return ''
        } else {
          return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--edit'
        }
      } else {
        return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--edit'
      }
    },
    toDetail(row) {
      this.$router.push({
        path: '/wly/make-ticket-notice/detail-quota',
        query: {
          id: row.invo_infoid
        }
      })
    },
    exportSign() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData.length) {
        return this.$message.warning('请选择有效数据！')
      }
      // if (checkData.length > 1 && !checkData.every(item => item.zzfld00001h === checkData[0].zzfld00001h)) {
      //   return this.$message.error('所选数据不是同一个营销单元，请重新选择！')
      // }
      if (checkData.some(item => item.inv_status !== 'E005')) {
        return this.$message.error('存在单据未审核通过，不允许导出！')
      }

      checkData.forEach((item, i) => {
        item._index = i + 1
      })
      const columns = [
        { field: '_index', title: '序号', width: 60, xlsxFmt: {}},
        { field: 'cust_name', title: '开票客户名称', width: 200, xlsxFmt: {}},
        { field: 'order_cust_name', title: '订单客户名称', width: 200, xlsxFmt: {}},
        { field: 'plan_type_text', title: '计划类型', width: 160, xlsxFmt: {}},
        { field: 'description', title: '产品名称', width: 250, xlsxFmt: {}},
        { field: 'use_zzfld9', title: '数量(件)', xlsxFmt: { t: 'n' }},
        { field: 'use_bot', title: '数量(瓶)', xlsxFmt: { t: 'n' }},
        { field: 'invo_id', title: '发票号', xlsxFmt: {}},
        { field: 'manual_invo', title: '提货票号', xlsxFmt: {}},
        { field: 'warehouse_text', title: '仓库', xlsxFmt: {}},
        { field: 'zzfld00001h_text', title: '营销单元', xlsxFmt: {}},
        { field: 'mak_date', title: '开票日期', xlsxFmt: {}}
      ]
      frontExport(columns, checkData, `发运签收表`)
    },
    saveESM(type) {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData.length) {
        return this.$message.error('请选择有效数据！')
      }
      this.approve(checkData, type)
    },
    printDialog(mode, selects, sign_type) {
      const params = {
        user_bp: this.role.USER_BP,
        mode,
        selects,
        sign_type
      }
      printEMSAddress(params).then(res => {
        if (res.msgtype === 'S') {
          this.showDialog = true
          var uint8Array = new Uint8Array(hexToBytes(res.data))
          var blob = new Blob([uint8Array], { type: 'application/pdf' })
          this.url = URL.createObjectURL(blob)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    showSigin() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData.length) {
        return this.$message.warning('请选择有效数据！')
      }
      this.showTypeDialog = true
    },
    printEMS() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData.length) {
        return this.$message.warning('请选择有效数据！')
      }

      this.printDialog('EMS', checkData)
    },
    submitType() {
      const data = this.$refs.xTable2.getRadioRecord()
      if (!data) return
      this.printReport(data.name)
      this.showTypeDialog = false
    },
    printReport(type) {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      this.printDialog('QSB', checkData, type)
    },
    async approve(row, mode) {
      // if (mode === 'APPROVE') {
      //   await this.$confirm(`是否确认审核通过?`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   })
      // }
      this.loading = true
      const params = {
        mode,
        user_bp: this.role.USER_BP
      }
      if (mode === 'BUTTON_EMS') {
        params.selects = row
      } else {
        params.info = row
      }
      try {
        const result = await apiApprove(params)
        if (result.msgtype === 'S') {
          this.$message.success(result.message)
          this.queryData()
        } else {
          this.loading = false
          return this.$message.warning(result.message)
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    async editNum() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      const params = {
        USER_BP: this.$store.getters.role.USER_BP,
        HEAD: checkData
      }
      const res = await apiEditInvoice(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
      } else {
        this.$message.warning(res.message)
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        mode:'RED_RUSH',
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiMakeInvoiceDetailList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns.filter(row => row.field !== 'approve'), checkData, '制票通知单明细')
        return
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiMakeInvoiceDetailList)
      frontExport(this.gridOptions.columns.filter(row => row.field !== 'approve'), data, '制票通知单明细')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
.button-approve{
  display: inline-block;
  padding: 0 5px;
  height: 22px;
  line-height: 22px !important;
  background: #ff1d3d;
  color: #fff;
  cursor: pointer;
  border-radius: 2px;
  box-shadow: 1px 1px 7px #666;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/invoiceDetailQuery.vue